var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { getServices } from 'client/fetch/services';
import { FieldSelect } from 'components/Forms/FieldSelect';
const ServiceSelect = (_a) => {
    var { title, placeholder, name, className } = _a, otherProps = __rest(_a, ["title", "placeholder", "name", "className"]);
    const services = getServices();
    return (React.createElement(FieldSelect, Object.assign({ title: title, name: name, disabled: !services.data, className: className || 'drop-box', placeholder: services.isFetching ? 'Please wait...' : placeholder, options: services.data
            ? services.data.map((s) => ({ label: s.name, value: s.id })).sort((s1, s2) => s1.label.localeCompare(s2.label))
            : [] }, otherProps)));
};
export default ServiceSelect;
